import {API} from 'aws-amplify';
import {awsApiName} from '../../shared/amplify/amplify-utils';
import {RequestBody} from '../../entity/core/request-body';
import {BusinessRecord} from '../../entity/model/business-record';

export default class BusinessRecordAgent {
    
  createBusinessRecords = async (requestBody: RequestBody): Promise<BusinessRecord[] | string> => {
    return await API.post(awsApiName, '/business-records', requestBody);
  }
}
